import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import SimplePicker from 'Helpers/SimplePicker';
import IncludedScenarioChart from 'Components/ComponentLibrary/Organisms/IncludedScenarioChart';
import TitledPaperRichTextDisplay from 'Components/ComponentLibrary/Molecules/TitledPaperRichTextDisplay';

const Content = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <PageContentContainer>
      <PageContentTop
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <SimplePicker
        resource={resource}
        relationship={fr.relationships.facetPlanChartData.name}
        hasRelationship={({ relationship }) => (
          <IncludedScenarioChart relationship={relationship} />
        )}
      />
      {resource.attr('activationDetails')
        ? <TitledPaperRichTextDisplay
          label={resource.metaField('activationDetails').attr('prompt')}
          value={resource.attr('activationDetails')}
        /> : null}
      {resource.attr('upcomingInformation')
        ? <TitledPaperRichTextDisplay
          label={resource.metaField('upcomingInformation').attr('prompt')}
          value={resource.attr('upcomingInformation')}
        /> : null}
    </PageContentContainer>
  );
};

export default Content;
